import React from "react";
import { Alert } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface OnboardingStepNoticeProps {
  variant: "success" | "error";
  requiresAttention?: boolean;
  children: React.ReactNode;
}

const OnboardingStepNotice: React.FC<OnboardingStepNoticeProps> = ({
  variant,
  requiresAttention = false,
  children,
}) => (
  <div className={s.noticeWrapper}>
    {requiresAttention && (
      <span className={s.requiresAttentionLabel}>Requires attention</span>
    )}
    <Alert
      color={variant === "success" ? "success" : "danger"}
      fade={false}
      className={variant === "success" ? s.successAlert : s.dangerAlert}
    >
      {children}
    </Alert>
  </div>
);

export default withStyles(s)(OnboardingStepNotice);
